export enum TrackingEvent {
  IconClick = `[UserIcon] Icon Click`,
}

export enum TrackingEventProperty {
  AvatarType = `Avatar Type`,
}
export enum AvatarType {
  Empty = `empty`,
  Name = `name`,
  Photo = `photo`,
}

export interface TrackingEventProperties {
  [TrackingEventProperty.AvatarType]: AvatarType;
}

export function track(event: TrackingEvent, properties: TrackingEventProperties) {
  mixpanel.track(event, properties);
}
